// app/javascript/controllers/storefront_controller.js
import { Controller } from "@hotwired/stimulus"

let currentOpenController = null

export default class extends Controller {
  static targets = ["panel", "button", "underline", "track", "mobileMenu", "cartSubmit", "cartAdded", "quoteSubmit", "quoteAdded", "quantitySelect"]

  connect() {
    this.open = false
    this._outsideClickHandler = (event) => this.handleOutsideClick(event)
    document.addEventListener("click", this._outsideClickHandler)

    // If you previously trapped Escape for the cart modal, drop it here.
    // Cart modal now owns its own keyboard handling.
  }

  disconnect() {
    document.removeEventListener("click", this._outsideClickHandler)
    if (currentOpenController === this) currentOpenController = null
  }

  // Generic navbar dropdown / panel toggling
  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (currentOpenController && currentOpenController !== this) {
      currentOpenController.close()
    }

    if (this.open) {
      this.close()
      currentOpenController = null
    } else {
      this.open = true
      this.panelTarget?.classList.remove("hidden")
      this.buttonTarget?.classList.remove("text-gray-700")
      this.buttonTarget?.classList.add("text-yellow-700")
      this.underlineTarget?.classList.add("bg-yellow-700")
      currentOpenController = this
    }
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  close() {
    if (!this.open) return
    this.panelTarget?.classList.add("hidden")
    this.buttonTarget?.classList.remove("text-yellow-700")
    this.buttonTarget?.classList.add("text-gray-700")
    this.underlineTarget?.classList.remove("bg-yellow-700")
    this.open = false
    if (currentOpenController === this) currentOpenController = null
  }

  // Carousel helpers (unchanged)
  scrollNext() {
    this.trackTarget.scrollBy({ left: this.slideWidth, behavior: "smooth" })
  }

  scrollPrev() {
    this.trackTarget.scrollBy({ left: -this.slideWidth, behavior: "smooth" })
  }

  get slideWidth() {
    const slide = this.trackTarget.querySelector(":scope > div")
    const width = slide ? slide.offsetWidth + parseInt(getComputedStyle(slide).marginRight) : 0
    return width
  }

  // Mobile menu
  openMenu() { this.mobileMenuTarget.classList.remove("hidden") }
  closeMenu() { this.mobileMenuTarget.classList.add("hidden") }

  // Cart add feedback (kept)
  cartAdded(event) {
    if (event.detail.success) {
      this.cartSubmitTarget.classList.add("hidden")
      this.cartAddedTarget.classList.remove("hidden")
      setTimeout(() => {
        this.cartSubmitTarget.classList.remove("hidden")
        this.cartAddedTarget.classList.add("hidden")
      }, 5000)
      this.emitAnalyticsAddToCart(event.target)
    }
  }

  // Quote add feedback
  quoteAdded(event) {
    if (event.detail.success) {
      this.quoteSubmitTarget.classList.add("hidden")
      this.quoteAddedTarget.classList.remove("hidden")
      setTimeout(() => {
        this.quoteSubmitTarget.classList.remove("hidden")
        this.quoteAddedTarget.classList.add("hidden")
      }, 5000)
    }
  }


  update() { this.element.requestSubmit() }
  remove() { this.element.querySelector("form[data-destroy]").requestSubmit() }

  emitAnalyticsAddToCart(form) {
    if (!form || !form.dataset) return
    const raw = form.dataset.analyticsItem
    if (!raw) return

    let item
    try {
      item = JSON.parse(raw)
    } catch (error) {
      console.warn("Analytics item payload malformed", error)
      return
    }

    const quantityInput = form.querySelector("[name='quantity']")
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1
    const safeQuantity = Number.isFinite(quantity) && quantity > 0 ? quantity : 1
    const value = (item.price || 0) * safeQuantity

    document.dispatchEvent(
      new CustomEvent("oe2:analytics:add_to_cart", {
        detail: {
          currency: null,
          value,
          items: [
            {
              ...item,
              quantity: safeQuantity
            }
          ]
        }
      })
    )
  }
}
